var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: _vm.modalId } }, [
    _vm.open
      ? _c(
          "div",
          {
            staticClass:
              "modal-holder fixed top-0 left-0 w-full h-full backdrop-blur-sm z-[1000] px-[20px] md:px-[32px] py-[64px] flex items-center justify-center cursor-pointer",
            on: {
              click: function($event) {
                _vm.open = false
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "bg-brown-400 w-full p-[32px] h-auto lg:max-w-[900px] relative overflow-hidden flex flex-row gap-[32px] cursor-default",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", {
                  staticClass:
                    "far fa-times text-white absolute right-[16px] top-[16px] cursor-pointer text-20 z-10",
                  on: {
                    click: function($event) {
                      _vm.open = false
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "hidden llg:flex flex-col gap-[32px] items-end mt-[-32px] ml-[-32px]"
                  },
                  [
                    _c("div", {
                      staticClass:
                        "absolute top-[432px] left-[calc(-122px-32px)] h-[350px] w-[350px]",
                      domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("scan-form", {
                  attrs: {
                    formId: _vm.data.form_id,
                    title: _vm.data.title,
                    subtitle: _vm.data.subtitle,
                    description: _vm.data.description
                  }
                })
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }